import { createSlice } from '@reduxjs/toolkit';

// Incident data currently only covers 2025, so default the dashboard filters
// to that year instead of "now" (which would show an empty range once the
// current year moves past 2025).
export const DEFAULT_INITIAL_DATE = new Date('2025-01-01').getTime();
export const DEFAULT_FINAL_DATE = new Date('2025-12-31').getTime();

const initialState = {
  finalDate: DEFAULT_FINAL_DATE,
  initialDate: DEFAULT_INITIAL_DATE,
  filterKey: 'incidentDate',
};

const dateRangeFilterSlice = createSlice({
  name: 'incidentDateFilter',
  initialState,
  reducers: {
    finalDateFilterChanged(state, action) {
      state.finalDate = action.payload;
    },
    initialDateFilterChanged(state, action) {
      state.initialDate = action.payload;
    },
    filterKeyChanged(state, action) {
      state.filterKey = action.payload;
    },
  },
});

export const {
  finalDateFilterChanged,
  initialDateFilterChanged,
  filterKeyChanged,
} = dateRangeFilterSlice.actions;

export default dateRangeFilterSlice.reducer;

export const selectInitialDate = (state) =>
  state.incidentDateFilter.initialDate;
export const selectFinalDate = (state) => state.incidentDateFilter.finalDate;
